import { LegalLayout, Section } from "@/components/LegalLayout";

export default function Terms() {
  return (
    <LegalLayout title="Termini e Condizioni" updated="giugno 2026" otherTo="/privacy" otherLabel="Leggi la Privacy Policy →">
      <p data-testid="terms-intro">
        I presenti Termini e Condizioni ("Termini") regolano l'utilizzo del servizio <strong>MenuOne</strong>, una
        piattaforma software (SaaS) che consente ai ristoratori di creare e gestire il proprio menù digitale. Registrando
        un account o utilizzando il servizio accetti integralmente i presenti Termini.
      </p>

      <Section n="1" title="Descrizione del servizio">
        <p>MenuOne è un'applicazione web che permette ai locali (ristoranti, bar, pizzerie, ecc.) di:</p>
        <ul className="list-disc pl-6 space-y-1.5">
          <li>creare un <strong>menù digitale</strong> organizzato in categorie e piatti, con foto, descrizioni e prezzi;</li>
          <li>generare un <strong>QR Code</strong> e un link pubblico da mostrare ai clienti al tavolo o sui social;</li>
          <li>aggiornare il menù <strong>in tempo reale</strong>, senza dover ristampare nulla;</li>
          <li>gestire più menù e scegliere tra diversi <strong>design</strong> grafici (secondo il piano);</li>
          <li>ricevere <strong>ordini personalizzati</strong> dai clienti, gestire una <strong>lista d'attesa</strong> e ricevere notifiche (secondo il piano);</li>
          <li>abilitare il <strong>pagamento del conto al tavolo</strong> tramite Stripe (piani Pro e Business);</li>
          <li>utilizzare funzioni di <strong>intelligenza artificiale</strong> per generare descrizioni e traduzioni dei piatti.</li>
        </ul>
      </Section>

      <Section n="2" title="Registrazione e account">
        <p>
          Per utilizzare il servizio è necessario creare un account fornendo dati veritieri e aggiornati. L'utente è
          responsabile della riservatezza delle proprie credenziali e di ogni attività svolta tramite il proprio account.
          Il servizio è riservato a soggetti maggiorenni e a chi opera nell'ambito della propria attività professionale.
        </p>
      </Section>

      <Section n="3" title="Piani, prova gratuita e rinnovo">
        <ul className="list-disc pl-6 space-y-1.5">
          <li>MenuOne offre piani mensili (Basic, Avanzato, Pro, Business) e un piano a tempo giornaliero.</li>
          <li>I piani mensili includono una <strong>prova gratuita di 14 giorni</strong>: i dati della carta sono richiesti al momento dell'attivazione, ma <strong>nessun addebito</strong> viene effettuato durante i 14 giorni. Al termine della prova l'utente può continuare con il piano a pagamento oppure disdire e tornare al piano Free.</li>
          <li>Al termine della prova, l'abbonamento si attiva automaticamente al prezzo del piano scelto e si rinnova periodicamente, salvo disdetta.</li>
          <li>Puoi gestire o disdire l'abbonamento in qualsiasi momento dal portale abbonamenti disponibile nella sezione <em>Abbonamento</em>.</li>
        </ul>
      </Section>

      <Section n="4" title="Prezzi e pagamenti">
        <p>
          Tutti i prezzi indicati sono comprensivi di IVA. I pagamenti sono elaborati in modo sicuro tramite <strong>Stripe</strong>.
          MenuOne non conserva i dati completi delle carte di pagamento. In caso di mancato pagamento, l'accesso alle
          funzioni a pagamento potrà essere sospeso.
        </p>
      </Section>

      <Section n="5" title="Obblighi dell'utente">
        <p>L'utente si impegna a:</p>
        <ul className="list-disc pl-6 space-y-1.5">
          <li>inserire contenuti (testi, prezzi, immagini) veritieri, di cui detiene i diritti, e non lesivi di diritti di terzi;</li>
          <li>non utilizzare il servizio per finalità illecite, ingannevoli o vietate dalla legge;</li>
          <li>rispettare le normative applicabili in materia di somministrazione, allergeni, prezzi e tutela dei consumatori.</li>
        </ul>
        <p>MenuOne non è responsabile dell'accuratezza dei contenuti inseriti dall'utente nel proprio menù.</p>
      </Section>

      <Section n="6" title="Proprietà intellettuale">
        <p>
          Il software, il marchio e la grafica di MenuOne sono di proprietà del Titolare. I contenuti caricati dall'utente
          restano di proprietà dell'utente, che concede a MenuOne una licenza limitata al solo scopo di erogare il servizio.
        </p>
      </Section>

      <Section n="7" title="Cancellazione e recesso">
        <p>
          L'utente può cancellare il proprio account in qualsiasi momento dalla sezione <em>Account</em>. La cancellazione
          comporta l'eliminazione dei dati e dei contenuti associati, secondo quanto indicato nella Privacy Policy, e
          l'interruzione dell'eventuale abbonamento attivo.
        </p>
      </Section>

      <Section n="8" title="Limitazione di responsabilità">
        <p>
          Il servizio è fornito "così com'è". Pur impegnandoci a garantire continuità e sicurezza, non possiamo assicurare
          che il servizio sia sempre privo di interruzioni o errori. Nei limiti consentiti dalla legge, MenuOne non è
          responsabile per danni indiretti derivanti dall'uso o dal mancato uso del servizio.
        </p>
      </Section>

      <Section n="9" title="Legge applicabile e foro competente">
        <p>
          I presenti Termini sono regolati dalla <strong>legge italiana</strong>. Per i rapporti con i consumatori resta
          fermo il foro del luogo di residenza o domicilio del consumatore, ove inderogabile per legge. Per ogni altra
          controversia sarà competente il foro del luogo in cui ha sede il Titolare.
        </p>
      </Section>

      <Section n="10" title="Titolare e contatti">
        <p>
          Il servizio è erogato da <strong>Menuone</strong>, P.IVA <strong>03102260647</strong>, con sede in
          <strong> Sant'Angelo dei Lombardi (AV)</strong>. Per qualsiasi informazione sui presenti Termini puoi
          contattarci a <a href="mailto:creamenuone@gmail.com" className="text-[#5aa469] hover:underline">creamenuone@gmail.com</a>.
        </p>
      </Section>
    </LegalLayout>
  );
}
